module.exports = __webpack_public_path__ + "img/balanced-logo.8a295db9.svg";